import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconThumbsDown$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconThumbsDown extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b4d4b2fc8adeb5f664f2336fc9c954dcd0a157e5', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7d415b73c2fa46fac2cb0a8bc0f17d0ad54c14e0', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '4b2145d44504b3ece403a5a635d819b2091c7a59', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 14.002a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5zM6.48 6.012a.51.51 0 0 0-.42.22C4.73 8.163 4 9.373 4 11.853a9 9 0 0 0 .33 2.56.49.49 0 0 0 .47.36c.264 0 1.424-.126 2.53-.246.571-.062 1.128-.123 1.54-.163a19 19 0 0 0-.48 2.63c0 1.32.88 2.01 2.56 2.01.86 0 1.15-.07 1.28-.43l2.14-5.71c.098-.238.143-.494.13-.75v-4.35a.46.46 0 0 0-.18-.38c-1.491-1.281-3.567-1.31-7.31-1.363zm.52 1.5c3.96 0 5.08.18 6 .75v3.97l-1.96 5.27c-.85 0-1.15-.05-1.15-.51 0-.317.202-1.253.518-2.722l.202-.937a.477.477 0 0 0-.54-.6l-4.48.45a9 9 0 0 1-.09-1.33A6.65 6.65 0 0 1 7 7.513", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-thumbs-down", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-thumbs-down"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-thumbs-down":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconThumbsDown$1);
            }
            break;
    } });
}

const CosmosIconThumbsDown = CosmosIconThumbsDown$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconThumbsDown, defineCustomElement };
